import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 获取客户评分列表
export const getCustomerRuleList = params => {
    return get("/admin/ruleEngine/userScore/versionList", params);
};
// 获取客户评分详情
export const getCustomerRuleDetail = params => {
    return get("/admin/ruleEngine/userScore/ruleDetail", params);
};
// 获取客户评分默认规则详情
export const getCustomerRuleDefault = params => {
    return get("/admin/ruleEngine/userScore/ruleDefault", params);
};
// 新增客户评分
export const addCustomerRule = params => {
    return post("/admin/ruleEngine/userScore/add", params);
};
// 编辑客户评分
export const editCustomerRule = params => {
	return post("/admin/ruleEngine/userScore/edit", params);
};


// WEBPACK FOOTER //
// ./src/api/customerRule.js